// all times handled as milliseconds
export function getImageFromAnimation(animation, time) {
    const duration = animation.frames[animation.frames.length - 1].time

    if(animation.isLoop == true) {
        time %= duration
    }

    if(time > duration) {
        time = duration
    }

    return (animation.frames.find((frame, index) => {
        if(animation.frames[index + 1] == undefined
        || animation.frames[index + 1].time >= time) {
            return true
        }
    }) || {}).image
}

export function isAnimationOver(animation, startTime = 0) {
    const duration = animation.frames[animation.frames.length - 1].time

    if(animation.isLoop == true) {
        return false
    }
    // console.log(window.performance.now() - startTime > duration, Math.floor(window.performance.now()), startTime, duration)

    return window.performance.now() - startTime > (duration * 2) // WHY TIMES 2?? WHY???
}
